import { EntityStore } from './entity-store'

type RegistersStore = EntityStore<'registers'>

/**
 * Stores information on the retailer's registers.
 */
export const registersStore: RegistersStore = new EntityStore({
  entityStoreName: 'registers',
})
